import { cn } from '@/lib/utils/helpers'
import funnelIconSvg from '../assets/funnel.svg?raw'
import type { YardiToolbarFunnelIconProps } from '../types'

/** Same funnel SVG as Invitee list "Filters" toolbar for visual parity. */
export function YardiToolbarFunnelIcon({
  className,
  dataTestId = 'yardi-invite-toolbar-funnel-icon',
}: YardiToolbarFunnelIconProps) {
  return (
    <span
      data-testid={dataTestId}
      className={cn('inline-flex', className)}
      aria-hidden
      dangerouslySetInnerHTML={{ __html: funnelIconSvg }}
    />
  )
}
